const API = process.env.REACT_APP_API_URL || 'https://recruitai.pingitright.com/api';

export function labLiveSttUrl() {
  return `${String(API).replace(/^http/, 'ws')}/portal/stt-test/live`;
}

export function meetingLiveSttUrl(token) {
  return `${String(API).replace(/^http/, 'ws')}/portal/meeting/${encodeURIComponent(token)}/interview/stt-live`;
}

export function connectLabLiveStt({ url, onReady, onTranscript, onError, keyterms } = {}) {
  let closed = false;
  const params = new URLSearchParams();
  (keyterms || []).forEach((term) => {
    const value = String(term || '').replace(/\s+/g, ' ').trim();
    if (value.length >= 2) params.append('keyterm', value);
  });
  const qs = params.toString();
  const base = url || labLiveSttUrl();
  const ws = new WebSocket(qs ? `${base}?${qs}` : base);
  ws.binaryType = 'arraybuffer';

  ws.onmessage = (event) => {
    if (closed || typeof event.data !== 'string') return;
    let payload;
    try {
      payload = JSON.parse(event.data);
    } catch (_) {
      return;
    }
    if (payload.type === 'ready') onReady?.(payload);
    else if (payload.type === 'transcript') onTranscript?.(payload);
    else if (payload.type === 'error') onError?.(payload.error || 'deepgram_failed');
  };
  ws.onerror = () => {
    if (!closed && ws.readyState !== WebSocket.OPEN) onError?.('deepgram_failed');
  };
  ws.onclose = (event) => {
    if (closed) return;
    if (event.code && event.code !== 1000 && event.code !== 1005) {
      onError?.('deepgram_failed');
    }
  };

  const sendPcm = (buffer) => {
    if (!closed && ws.readyState === WebSocket.OPEN && buffer) ws.send(buffer);
  };

  const stop = () => {
    closed = true;
    try {
      if (ws.readyState === WebSocket.OPEN) ws.send('stop');
    } catch (_) { /* ignore */ }
    try { ws.close(); } catch (_) { /* ignore */ }
  };

  return { sendPcm, stop, socket: ws };
}
